import { connect } from "react-redux";
import { reduxForm, formValueSelector, SubmissionError } from "redux-form";
import { submissionErrorHandler } from "../submissionErrorHandler";
import { loginUserSuccess } from "containers/Auth/actions";

import * as api from "api/users";

// // Validation
// const validate = (values) => {
//   const errors = {}
//   phoneFieldValidate(errors, values)
//   return errors
// }

import DonorForm from "./form";

let initialValues;

const mapStateToProps = (state, ownProps) => {
  initialValues = { ...initialValues, ...ownProps.initialValues };

  let props = {
    // phoneNumber: state.donorWizard.formValues.phoneNumber,
  };

  return { initialValues, ...props };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (form) =>
      api
        .registerUser(form)
        .then((response) => {
          dispatch(loginUserSuccess(response.data.data[0]));
        })
        .catch((err) => submissionErrorHandler(err, "")),
  };
};

// Connect to the store using a container component
const withConnect = connect(mapStateToProps, mapDispatchToProps)(DonorForm);
const withForm = reduxForm({ form: "Login" })(withConnect);

export default withForm;
